<template>
  <div>
    <precise>
      <template v-slot:header>
        <el-alert
          show-icon
          title="请您阅读提示"
          description="请您先输入专家的身份证号码和手机号。1、如身份证号存在并且完善提交，您可直接选择入库。2、如不存在，请您新增入库"
          type="warning"
        ></el-alert>
      </template>
      <template v-slot:footer="props">
        <h4>
          平台中，不存在身份证号为
          <b>{{ props.idCard }}</b>
          ,请您单击
          <el-button
            type="primary"
            @click="handleBuilt(props.idCard, props.mobile)"
          >
            新增专家入库
          </el-button>
        </h4>
      </template>
    </precise>
  </div>
</template>

<script>
import Precise from '../components/Precise.vue';

export default {
  components: {
    Precise
  },
  methods: {
    handleBuilt(idCard, mobile) {
      this.$router.push(`/mavin/built?idCard=${idCard}&mobile=${mobile}`);
    }
  }
};
</script>

<style lang="scss">
body {
  padding: 30px;
}
</style>
